export const compareIp = (ip1, ip2) => {
  if (ip1 && ip2) {
    const octets1 = ip1.split(".").map(Number);
    const octets2 = ip2.split(".").map(Number);

    return octets1.every((octet1, index) => octet1 === octets2[index]);
  }
  return false;
};
